import axios from "axios";
import {store} from '../configureStore';
import https from 'https';
import { toast } from 'react-toastify';

export const makeAPICall = async (url,method,data,headers) => {

    let storedData = store.getState().common
    //console.log('val inside apicall ',storedData)
    //console.log(`token url  ${(url)}`)

    let  clientId = storedData.clientId
    //console.log('clientidbefore',clientId);
    //let  clientSecret = storedData.clientSecret
    //console.log('clientsecretbefore',clientSecret);
    let  access_token = storedData.access_token
    //console.log('acesstoke apicall' ,access_token)

    try{

        if (url !== 'https://rpapi.consent.jiolabs.com/oauth2/v2.0/token' &&
            url !== 'http://10.162.6.84:9018/v1.4/consent/token' &&
            url !== 'https://api.consent.jio.com/oauth2/v2.0/token' &&
            url !== 'https://rpapi.consent.jio.com/oauth2/v2.0/token'&&
            url !== 'http://10.162.6.84:9016/v1.5/consent/initOtp' &&
            url !== 'http://10.173.184.4:9017/v1.4/consent/token' &&
            url !== 'https://rpapi.consent.jiolabs.com/consent/v1.5/token' ){
               // console.log("INSIDE IF")
            headers['clientId']= clientId
            //headers['clientSecret']= clientSecret
            headers['Authorization']= `Bearer ${access_token}`
        }
       
        headers['Content-Type']= "application/json"
        headers['txnId']= "d52fdf2e-3c6b-4e8c-91f0-91f98e27bb5b"
       // headers['txnId']= "fd1e4eee-afde-48f4-9495-a83fef8a48ed"
        // SubscriptionKey / OAuth client secrets are injected by the BFF wrapper — never send from the SPA
        headers.method=method

        let apiObjAxios = {url,method}
        apiObjAxios.headers=headers
        
        if (method === 'POST' || method === 'PUT' || method === "PATCH") {
            apiObjAxios.data = data;
        }
       // console.log(`HTTP request from makeAPICall ${JSON.stringify(apiObjAxios)}`);
        return new Promise((resolve, reject) => {
            axios(apiObjAxios)
                .then(async response => {
                    resolve(response);
                }).catch(err => {
                    if (err.response && err.response.data) {
                        reject(err.response.data);
                    } else {
                        reject(err);
                    }
                });
        });
    }
    catch (error) {
        throw new Error('Something went wrong', error.response ? error.response.data : error);
    }
    }



    export const deleteAPICall = async (url,data,headers) => {
        try{
            // console.log(`Request ${JSON.stringify(data)}`)
            headers['crypto-mode'] =false
            let apiObjAxios = {url}
            apiObjAxios.headers=headers
            // console.log(`HTTP request from deleteAPICall ${JSON.stringify(apiObjAxios)}`);
            return new Promise ((resolve,reject)=>{
            axios.delete(url,{data,headers})
                .then(async response => {
                    // console.log(`Response from deleteAPICall with data ${JSON.stringify(response.data)}`);
                    resolve(response.data)
                }).catch(err => {
                    // console.log(`Error message HTTP Call APICall Error Response ${JSON.stringify(err?.response)}`)
                    reject(err?.response)
                }) 
            })
        }
        catch(err){
            // console.log(`Error message ${err}`)
            throw new Error(`something went wrong`)
        }
    }
    

    export const scanApiCall = async (url,method,data,headers) => {
        try{

           // alert("calling scanner api with : "+url+" with method: "+method)
          
            let apiObjAxios = {url}

            headers['Content-Type']= "application/json"
            headers.method=method

            apiObjAxios.headers=headers
            apiObjAxios.method = method

            const agent = new https.Agent({ rejectUnauthorized: false });
            apiObjAxios.httpsAgent = agent;

            if(method==='POST' || method==='PUT'){
                apiObjAxios.data = data
            }

            return new Promise ((resolve,reject)=>{
                axios(apiObjAxios)
                    .then(async response => {
                        resolve(response.data)
                    }).catch(err => {
                        reject(err?.response)
                    }) 
            })
        }
        catch(err){
            throw new Error(`something went wrong`)
        }
    }
    
    